import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {FulfillmentSubTypeType} from "../../types/fulfillment-sub-type.type";

export class FulfillmentStepSelectItemComponent implements IController {
  step: any;

  public attempt: any;
  public fulfillmentSubTypeType: typeof FulfillmentSubTypeType = FulfillmentSubTypeType;

  /* @ngInject */
  constructor() {
  }

  ///////////////////////////////////////////////////

  $onInit() {

  };

  $onChanges(changes) {
    if (changes.step) {
      this._setActiveAttempt();
    }
  };

  private _setActiveAttempt() {
    if (!this.step) {
      this.attempt = undefined;
    } else {
      this.attempt = _.find(this.step.attempts, (a) => {
        return a.id === this.step.referenceId;
      })
    }
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentStepActiveAttemptServiceLink', {
    bindings: {
      step: '<'
    },
    template: require('./fulfillment-step-active-attempt-service-link.html').default,
    controller: FulfillmentStepSelectItemComponent
  });
